// extracted by mini-css-extract-plugin
export var gatsbyImageWrapper = "Card-module--gatsby-image-wrapper--06dad";
export var thumbnailHolder = "Card-module--thumbnailHolder--fb244";